import React, { useState } from 'react';
import GenericTable from 'shared/components/common/table/table';
import styles from './style.module.scss';
import { DelIcon, EditIcon, PlusIcon, ProjectNameIcon, StatusCheckIcon } from 'assets';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Heading from 'shared/components/common/heading/Heading';
import Switch2 from 'shared/components/common/switch2/Switch2';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import DeleteConfirmation from 'shared/modal/delete_confirmation/DeleteConfirmation';
import EditQuantityModal from 'shared/modal/sale_order_supplier/EditSoQuantityModal';

const InnerSoTable = ({ PoList, OffPage, setIsEdit, handleUpdateQuantity, handleDelete, isView = false, title = 'Sale Order' }) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const [selectDelUser, setSelectDelUser] = useState(null);
    const [openDelConfirm, setOpenDelConfirm] = useState(false);

    const closeDelConfirmation = () => setOpenDelConfirm(false);



    const subTotal = PoList?.reduce((sum, item) => {
        const total = (item.price || 0) * (item.quantity || 0);
        return sum + total;
    }, 0);

    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `Rs ${num.toFixed(2)}`;
    };


    // Edit State
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedItemForEdit, setSelectedItemForEdit] = useState(null);


    const confirmDelete = () => {
        if (selectDelUser !== null) {
            handleDelete(selectDelUser);
            closeDelConfirmation();
        }
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        SKU
                    </div>
                ),
                accessor: 'sku',
                Cell: ({ row }) => <div>{row.original?.sku}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Compatible Brand
                    </div>
                ),
                accessor: 'Compatible',
                Cell: ({ row }) => <div>{row.original?.competebleBrand?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Model
                    </div>
                ),
                accessor: 'as',
                Cell: ({ row }) => <div>{row.original?.product?.name}</div>
            },

            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Sub Categ.
                    </div>
                ),
                accessor: 'subCategory',
                Cell: ({ row }) => <div>{row.original?.sub_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Category
                    </div>
                ),
                accessor: 'categorys',
                Cell: ({ row }) => <div>{row.original?.product_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Brand
                    </div>
                ),
                accessor: 'brands',
                Cell: ({ row }) => <div>{row.original.brand?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Color
                    </div>
                ),
                accessor: 'color',
                Cell: ({ row }) => <div>{row.original.color}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Quantity
                    </div>
                ),
                accessor: 'quantity',
                Cell: ({ row }) => <div>{(row.original.quantity)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Price
                    </div>
                ),
                accessor: 'price',
                Cell: ({ row }) => <div>{formatPrice(row.original.price)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Total
                    </div>
                ),
                accessor: 'total',
                Cell: ({ row }) => <div>{formatPrice(row.original.price * row.original.quantity)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Action
                    </div>
                ),
                accessor: 'status',
                Cell: ({ row }) => (
                    <div className={classNames(styles.Statuses)} style={{ display: 'flex', gap: '10px' }}>
                        <EditIcon
                            className="pointer"
                            onClick={() => {
                                setSelectedItemForEdit({
                                    index: row.index,
                                    quantity: row.original.quantity,
                                    productName: row.original?.product?.name,
                                    maxQuantity: row.original?.maxQuantity
                                });
                                setOpenEditModal(true);
                            }}
                        />
                        <DelIcon
                            className="pointer"
                            onClick={() => {
                                setOpenDelConfirm(true);
                                setSelectDelUser(row.index);
                            }}
                        />
                    </div>
                )
            }
        ],
        [theme, PoList, isView]

    );
    return (
        <div className={'text-start'}>
            <div className={styles.Header}>
                <Heading heading={title} headingStyle={styles.Heading} />
            </div>

            <GenericTable
                columns={isView ? columns.filter(col => col.accessor !== 'status') : columns}
                innerpo={'innerpoOn'}
                OffPage={OffPage}
                data={PoList || []}
                TableWrapperStyle={classNames(styles.Table)}
            />

            <div className={styles.TableFooter}>
                <div className={styles.SubtotalRow}>
                    <strong>Subtotal:</strong> {PoList?.reduce((sum, item) => sum + (item.price * item.quantity), 0).toLocaleString()}
                </div>
            </div>

            {/* Edit Modal Component */}
            {/* Edit Modal */}
            {openEditModal && (
                <EditQuantityModal
                    show={openEditModal}
                    handleClose={() => setOpenEditModal(false)}
                    selectedItem={selectedItemForEdit}
                    onUpdate={handleUpdateQuantity}
                />
            )}



            <DeleteConfirmation
                show={openDelConfirm}
                handleClose={closeDelConfirmation}
                DeleteHandler={confirmDelete}
                ConfimationHeading="Delete Item"
                Desc={'Are you sure you want to delete the Item?'}
            />
        </div>
    );
};
export default InnerSoTable;
